<template>
  <div class="account-summary-vue">
    <Header>
      <template v-slot:title>
        <span v-if="whitelabel === 'Blackstone'"> My Trading Accounts </span>
        <span v-else>
          {{ $t("account-summary") }}
        </span>
      </template>
      <template v-slot:buttons>
        <span class="inline-flex rounded-md">
          <button
            v-if="
              whitelabel !== 'Blackstone' &&
              whitelabel !== 'OrbitInvest' &&
              whitelabel !== 'VCGMarkets'
            "
            class="relative inline-flex items-center pr-4 pl-1 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50"
            type="button"
            @click="showAddDemoAccountModal = true"
          >
            <svg
              class="h-5 w-0 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("add-a-new-demo-account") }}
            </span>
            <span class="md:hidden flex">
              <svg
                class="h-5 mr-2 text-gray-700 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
              </svg>
              {{ $t("demo") }}
            </span>
          </button>
        </span>
        <span
          v-if="
            get_profile.state !== 'Demo' &&
            whitelabel !== 'Blackstone' &&
            whitelabel !== 'OrbitInvest' &&
            whitelabel !== 'VCGMarkets'
          "
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <button
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            type="button"
            @click="showAddAccountModal = true"
          >
            <svg
              class="h-5 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-trading-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </button>
        </span>
        <!-- #BR#74 - Mbeng Atemson - Become a Broker Request  mu- 09/04/2025 -->
         <!-- #BR#88 - Mbeng Atemson - Become a Broker Request  vc- 16/05/2025 -->
        <!-- #BR#52 - Mbeng Atemson - Become a Broker Request  Sc- 26/07/2025-->
        <span
          v-if="
            get_profile.state === 'Full' && (whitelabel ==='ICMMU' || whitelabel === 'ICMVC' || whitelabel === 'ICMSC')
          "
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <button
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            type="button"
            @click="showBecomeBrokerPopup = true"
          >
             <!-- ERR#48 mbeng 16/05/2025 add translation to broker button -->
            <span class="hidden md:flex">
              {{ $t("become-an-introducing-broker")}}
            </span>
            <span class="md:hidden">
              {{ $t("broker") }}
            </span>
          </button>
        </span>
        <span
          v-if="whitelabel === 'Blackstone'"
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <router-link
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            to="/add-new-live-account"
            type="button"
          >
            <svg
              class="h-5 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-trading-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </router-link>
        </span>
        <span
          v-if="whitelabel === 'Blackstone'"
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <router-link
            class="relative inline-flex items-center pr-4 pl-1 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50"
            to="/add-new-demo-account"
            type="button"
          >
            <svg
              class="h-5 mr-2 text-gray-700 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-demo-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </router-link>
        </span>
        <div
          class="flex gap-2 md:gap-4 flex-wrap justify-end"
          v-if="whitelabel === 'VCGMarkets'"
        >
          <LinkButton
            v-if="whitelabel === 'VCGMarkets' && get_profile.state === 'Demo'"
            to="/open-live-account"
            :button-text="$t('Complete registration')"
          />

          <LinkButton
            v-if="
              (get_profile.state === 'Limited' ||
                get_profile.state === 'Pending') &&
              whitelabel === 'VCGMarkets'
            "
            to="/upload-documents"
            :button-text="$t('Upload documents')"
          />
          <LinkButton
            v-if="whitelabel === 'VCGMarkets' && get_profile.state === 'Full'"
            to="/deposit-funds"
            :button-text="$t('Fund your account')"
          />
        </div>
      </template>
    </Header>
    <iframe
      v-if="whitelabel === 'Blackstone'"
      allowtransparency="true"
      border="0"
      height="100%"
      scrolling="yes"
      src="https://blackstonefutures.co.za/banner/"
      style="border: 0"
      width="100%"
    ></iframe>
    <h5
      v-if="whitelabel === 'Blackstone'"
      class="flex text-gray-700 text-sm mt-2 justify-center"
    >
      <svg
        class="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
      MT4 servers: BlackstoneFutures-LiveBravo | BlackstoneFutures-DemoBravo
    </h5>
    <div
      v-if="whitelabel !== 'OrbitInvest'"
      class="sm:px-6 bg-white flex overflow-auto whitespace-nowrap"
    >
      <div v-for="(backend, index) in get_demo_backend_accounts" :key="index">
        <button
          v-if="
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === 'Live').length !== 0 ||
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === 'Demo').length !== 0
          "
          :class="
            selectedTab === backend.backend.type
              ? 'border-b-2 border-blue-900'
              : ''
          "
          class="px-4 py-3 mr-4 focus:outline-none border-b-2 border-transparent inline-block whitespace-normal"
          @click="selectedTab = backend.backend.type"
        >
          <img
            v-if="backend.backend.type === 'DXTrade'"
            :src="checkAsset(backend.backend.type)"
            alt=""
            class="h-6 w-auto"
          />
          <img
            v-else
            :src="checkAsset(backend.backend.type)"
            alt=""
            class="h-6"
          />
        </button>
      </div>
    </div>
    <complete-id-identification
      v-if="
        $store.getters.get_profile.state !== 'Full' &&
        $store.getters.get_profile.state !== 'Demo' &&
        $store.getters.get_profile.state !== 'Limited' &&
        (whitelabel === 'ICMEU' ||
          whitelabel === 'ICMCapital' ||
          whitelabel === 'ICMMENA' ||
          whitelabel === 'GCCBrokers' ||
          whitelabel === 'TradiNext' ||
          whitelabel === 'ICMTrader' ||
          whitelabel === 'ICMAP' ||
          whitelabel === 'TD365' ||
          whitelabel === 'TDSouthAfrica' ||
          whitelabel === 'EagleGlobalMarkets' ||
          whitelabel === 'TradeCoreUK' ||
          whitelabel === 'OrbitInvest' ||
          whitelabel === 'OneTradingMarkets')
      "
      :title="
        $t('further-id-verification-required-to-progress-account-application')
      "
    >
    </complete-id-identification>
    <alert-message
      :show-title="whitelabel !== 'VCGMarkets'"
      v-if="this.alertMessage.message !== ''"
      :alertMessage="this.alertMessage.message"
      :link="this.alertMessage.link"
      :linkText="this.alertMessage.linkText"
    >
    </alert-message>
     <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
      <!-- <complet-id-identification
          v-if="whitelabel==='ICMMU' && profileLoaded && showTaxPopup">
          <TaxDetailsAlert/>
      </complet-id-identification>  -->
    <div
      v-if="
        $store.getters.get_profile.state === 'Full' &&
        whitelabel === 'OrbitInvest'
      "
      class="sm:p-6 mt-4"
    >
      <div class="p-2 text-gray-500 font-light flex summary-info">
        <span class="block">Trading Account</span>
        <div class="summary-info__data">
          Total investment
          <span class="font-medium">{{
            $store.getters.get_user_data.extra.total_investment
          }}</span>
        </div>
      </div>
      <div class="p-2 text-gray-500 font-light flex summary-info">
        <span class="block">Profit Account</span>
        <div class="summary-info__data">
          Cash Balance
          <span class="font-medium">{{
            $store.getters.get_user_data.extra.total_profits
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-for="(backend, index) in get_demo_backend_accounts"
      v-if="
        backend.backend.type === selectedTab && whitelabel !== 'OrbitInvest'
      "
      :key="index"
      class="sm:p-6 mt-4"
    >
    <!-- BR#157 -	ICMVC : trading accounts with backend ICMVC_MT4 (Live2) , not to display in ICM Access - 11/02/2026 Mbeng -->
      <div class="p-2 text-gray-500 font-light flex">
        <span class="block"> {{ $t("live-accounts") }} </span>
        <span class="px-1 bg-white border rounded text-sm mx-1 text-blue-900">
          {{
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === "Live") 
              .filter((item) => item.backend.name !== "ICMVC_MT4 (Live2)")
              .length
          }}
        </span>
      </div>
      <!-- BR#157	ICMVC : trading accounts with backend ICMVC_MT4 (Live2) , not to display in ICM Access - 11/02/2026 Mbeng -->
      <card
        v-for="(data, index) in get_account_data
          .filter((item) => item.backend.type === backend.backend.type)
          .filter((item) => item.backend.mode === 'Live')
          .filter((item) => item.backend.name !== 'ICMVC_MT4 (Live2)')"
        :key="index + 'Live'"
        :data="data"
      />
      <div class="p-2 text-gray-500 font-light mt-16 flex">
        <span class="block"> {{ $t("demo-accounts") }} </span>
        <span class="px-1 bg-white border rounded text-sm mx-1 text-blue-900">
          {{
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === "Demo").length
          }}
        </span>
      </div>
      <card
        v-for="(data, index) in get_account_data
          .filter((item) => item.backend.type === backend.backend.type)
          .filter((item) => item.backend.mode === 'Demo')"
        :key="index + 'Demo'"
        :data="data"
      />
    </div>
    <add-demo-account-modal
      v-if="showAddDemoAccountModal"
      @close="closeModal"
    />
    <add-live-account-modal v-if="showAddAccountModal" @close="closeModal"/>
    <!--  #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025 -->
    <BecomeABrokerPopup
      :visible="showBecomeBrokerPopup"
      @close="showBecomeBrokerPopup = false"
      @submit="sendBrokerRequest"
    />
    <gcc-demo-popup
      v-if="showGccDemoPopup"
      @close="closeGccPopup"
      @continue="continueGccPopup"
    ></gcc-demo-popup>
    <icm-academy-modal v-if="showIcmAcademyModalComputed" @close="closeModal" />
    <icm-popup v-if="showICMPopup" />
    <icmcapital-unsuitable-modal
      v-if="$store.getters.get_icm_capital_suitable_modal"
    />

    <proof-of-id-modal
      v-if="$store.getters.get_icm_proof_modal === 'ID Proof'"
      :documents="['ID Proof']"
    ></proof-of-id-modal>
    <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
     <!-- <TaxDetailsPopup v-if="whitelabel ==='ICMMU'&& $store.getters.get_profile.state === 'Full' && profileLoaded && showTaxPopup"
      :visible="showTaxPopup"
      :deadline="deadlineDate"
      @close="dismissPopup"
    />  -->
   <!-- #BR#103 Mbeng 14/07/2025 SwapFreePopup for the list of trading account groups -->
   <SwapFreeGroup v-if="showSwapFreePopup && profileLoaded"
      :visible="showSwapFreePopup"
      @close="closeModal">
    </SwapFreeGroup>

    <!-- BR#112 - Mbeng  - 26/08/2025 - add webinar popup -->
    <Webinar 
      :visible="showWebinarPopup"
      @close="handleWebinarClose"
    />

    <!-- BR#158 - Mbeng  - 12/02/2026 - add spotindices popup -->
    <SpotIndices 
      :visible="showSpotIndicesPopup"
      @close="handleSpotIndicesClose"
    />

    <!-- BR#124 - Mbeng  - 10/09/2025 - add webinar popup -->
    <Webinaren 
      :visible="showWebinarenPopup"
      @close="handleWebinarenClose"
    />

     <!-- BR#135 - Mbeng  - 15/10/2025 - add webinarAssia popup -->
    <WebinarAssia 
      :visible="showWebinarAssiaPopup"
      @close="handleWebinarAssiaClose"
    />

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MoneyFormat from "vue-money-format";
import AddDemoAccountModal from "@/views/trading-accounts/AddDemoAccountModal";
import AddLiveAccountModal from "@/views/trading-accounts/AddLiveAccountModal";
import Header from "@/components/Header";
import Card from "@/views/trading-accounts/Card";
import CompleteIdIdentification from "@/components/CompleteIdIdentification";
import GccDemoPopup from "@/views/trading-accounts/GccDemoPopup";
import IcmAcademyModal from "@/views/trading-accounts/IcmAcademyModal";
import IcmcapitalUnsuitableModal from "@/views/register/IcmcapitalUnsuitableModal";
import AlertMessage from "@/components/AlertMessage.vue";
import LinkButton from "@/components/LinkButton.vue";
import ButtonComponent from "@/components/Button.vue";
import IcmPopup from "@/views/trading-accounts/ICMPopup.vue";
import LimitedStateUpgradeModal from "@/views/LimitedStateUpgradeModal.vue";
import ProofOfIdModal from "@/views/ProofOfIdModal.vue";

// #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
import BecomeABrokerPopup from "./BecomeABrokerPopup.vue"; 

import TaxDetailsAlert from "@/components/TaxDetailsAlert.vue"; //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
import TaxDetailsPopup from "@/components/TaxDetailsPopup.vue"; //BR#98 Mbeng 9/06/2025 For ICMMU Tax details

import SwapFreeGroup from "@/components/SwapFreeGroup.vue"; //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts groups
import Webinar from "@/components/Webinar.vue"; //  BR#112	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
import Webinaren from "@/components/Webinaren.vue";  //BR#124
import SpotIndices from "@/components/SpotIndices.vue"; //BR#158
import WebinarAssia from "@/components/WebinarAssia.vue";  //BR#135
export default {
  name: "AccountSummary",
  components: {
    ProofOfIdModal,
    LimitedStateUpgradeModal,
    IcmPopup,
    ButtonComponent,
    LinkButton,
    Card,
    AddDemoAccountModal,
    AddLiveAccountModal,
    Header,
    "money-format": MoneyFormat,
    CompleteIdIdentification,
    AlertMessage,
    GccDemoPopup,
    IcmAcademyModal,
    IcmcapitalUnsuitableModal,
    BecomeABrokerPopup,   // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
    TaxDetailsAlert,  //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    TaxDetailsPopup, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details

    SwapFreeGroup, //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading account groups
    SpotIndices, //BR#158 Mbeng Popup: Margin Requirement Changes for Spot Indices 12/02/2026
    Webinar,  // BR#112	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
    Webinaren,  // BR#124	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
    WebinarAssia,  // BR#135	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC  Malasia, Indonesia, thailand 15/10/2025 Mbeng
  },
  data() {
    return {
      showAddDemoAccountModal: false,
      showAddAccountModal: false,
      showBecomeBrokerPopup: false,  // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
      showMenu: false,
      stage: "",
      whitelabel: process.env.VUE_APP_WHITELABEL,
      selectedTab: "",
      showGccDemoPopup: false,

      intervalId: null,
      accountDataIntervalId: null,

      showSwapFreePopup: false, //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts groups
      showWebinarPopup: false, //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
      showSpotIndicesPopup: false, //BR158 - mbeng -12/02/2026 - Popup: Margin Requirement Changes for Spot Indices
      showWebinarenPopup: false, //BR#124 - Mbeng  - 26/08/2025 
      showWebinarAssiaPopup: false, //BR#135 - Mbeng  - 15/10/2025 

      showTaxPopup: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      menuLocked: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      userLoaded: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      deadlineDate: new Date("2025-04-15T23:59:59"), //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    };
  },
  computed: {
    ...mapGetters([
      "get_account_data",
      "get_profile",
      "get_user_data",
      "get_icm_academy_modal",
      "get_icm_capital_suitable_modal",
    ]),

    //BR#112  - Mbeng  - 26/08/2025 - add webinar popup - BR#124 - 10/09/2024
    profileLang() {
      return this.get_profile?.profile?.language || null;
    },
    profileWL() {
      return this.get_profile?.whitelabel || null;
    },
    profileCountry() {
      return this.get_profile?.address?.addr_country || null;
    
    },

    alertMessage() {
      let message = "";
      let link = "";
      let linkText = "";

      const profile = this.$store.getters.get_profile;
      const trading_days = this.$store.getters.get_trading_days;
      const state = profile.state;

      if (this.whitelabel === "VCGMarkets" && state === "Limited") {
        if (trading_days === null) {
          return {
            message: "Please, make a deposit transaction.",
            link: "/deposit-funds",
            linkText: "Deposit funds",
          };
        } else {
          if (trading_days === 0) {
            return {
              message: "Please verify your account to enable deposits.",
            };
          }
          return {
            message: `Please, upload your documents in next ${trading_days} days.`,
          };
        }
      }

      if (
        (this.whitelabel === "ICMVC" && state === "Pending") ||
        (this.whitelabel === "ICMSC" && state === "Pending") || //BR#52
        (this.whitelabel === "ICMMU" && state === "Pending")
      ) {
        // documents status
        // 1 - pending
        // 2 - approved
        // 3 - rejected
        // 4 - failed
        const documents = this.$store.getters.get_uploaded_documents?.results;
        const idProof = documents?.find(
          (document) => document.document_type === "ID Proof"
        );
        // if (documents?.length === 0 && this.whitelabel === "ICMVC") {
        //   message = this.$t(
        //     "further-id-verification-required-to-progress-account-application"
        //   );
        //   //link = "/upload-documents";
        //  // linkText = "Click here to upload.";
        // }

        //#BR#23 - mbeng Atemson - 23/10/2024 - KYC verification for iCMMU 
        //#BR#73 - mbeng Atemson - 23/10/2024 - KYC verification for iCMVC 
        //#BR#52 - mbeng Atemson - 25/7/2025 - KYC verification for iCMSC 
        if (documents?.length === 0 && (this.whitelabel === "ICMMU" || this.whitelabel === 'ICMVC' || this.whitelabel === 'ICMSC')) {
          message = this.$t(
            "KYC verification is pending, please contact Support Team." 
          );
          //#BR#23 - Removed click here to upload link for iCMMU - mbeng Atemson - 23/10/2024
          //link = "/upload-documents";     
          //linkText = "Click here to upload.";
        }


        if (idProof) {
          if (idProof?.status === 1) {
            message =
              "We're currently verifying your details. Please bear with us.\n" +
              "Thank you for your patience.";
          }
          //#BR#73 - KYC verification for iCMMU - mbeng Atemson - 09/04/2025
          // if (idProof.status === 3 && state === "Pending" && this.whitelabel === "ICMVC") {
          //   message =
          //     "Further ID verification required to progress account application.";
          //   link = "/upload-documents";
          //   linkText = "Click here to upload.";
          // }

          //#BR#23 - KYC verification for iCMMU - mbeng Atemson - 23/10/2024
          //#BR#73 - KYC verification for iCMMU - mbeng Atemson - 09/04/2025
          //#BR#52 - KYC verification for iCMSC - mbeng Atemson - 24/07/2025
          if (idProof.status === 3 && state === "Pending" && (this.whitelabel === "ICMMU" || this.whitelabel ==="ICMVC" || this.whitelabel === 'ICMSC')) {
            message =
              "KYC verification is pending, please contact Support Team.";

            //#BR#23 - Removed click here to upload link for iCMMU - mbeng Atemson - 23/10/2024
            //link = "/upload-documents";
            //linkText = "Click here to upload.";
          }
        }
      }

      return {
        message,
        link,
        linkText,
      };
    },
    get_demo_backend_accounts() {
      let data = this.$store.getters.get_demo_backend_accounts;
      if (this.$store.getters.get_demo_backend_accounts.length === 0) {
        data = this.$store.getters.get_live_backend_accounts;
      }
      let accountData = this.$store.getters.get_account_data;
      if (accountData.length > 0) {
        let result = accountData.filter(function (o1) {
          // filter out (!) items in result2
          return !data.some(function (o2) {
            return o1.backend.type === o2.backend.type; // assumes unique id
          });
        });
        result = data.concat(result).reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.backend.type === o.backend.type &&
                obj.backend.type === o.backend.type
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);

        // client wanted MT4 to be always as first tab and cTrader to be last tab
        // we check if there is a object with backend type of MT4
        // if it does, we check if its Index is not in the first position of bekend accounts
        // if its not, we reverse the order of array so he ends up in first place
        const mt4exist = result.some((object) => object.backend.type === "MT4");
        if (mt4exist) {
          if (
            result.findIndex((object) => object.backend.type === "MT4") !== 0
          ) {
            result.reverse();
          }
        }

        // this will loop through all trading backend types and check if it has active accounts
        // if it has, we can then set the selected tab to that one
        // this is places so we dont select a tab that we might not show, since we added a filter not to show tabs with no accounts
        for (const key in result) {
          if (
            accountData
              .filter((item) => item.backend.type === result[key].backend.type)
              .filter((item) => result[key].backend.mode === "Live").length !==
              0 ||
            accountData
              .filter((item) => item.backend.type === result[key].backend.type)
              .filter((item) => result[key].backend.mode === "Demo").length !==
              0
          ) {
            this.selectedTab = result[key].backend.type;
          }
        }

        // this function will sort tabs (backend types) based on the number of trading accounts that have that backend type
        // we loop through all backend types and then add all live and demo accounts with that bakend types, then compare with live + demo accounts from the other backend type from the array
        // this is the logic (p1, p2) => (p1.price < p2.price) ? 1 : (p1.price > p2.price) ? -1 : 0);
        // code taken from here https://www.scaler.com/topics/javascript-sort-an-array-of-objects/
        if (this.whitelabel === "TradeCoreUK") {
          let sortedProducts = result.sort((p1, p2) =>
            parseInt(
              accountData
                .filter((item) => item.backend.type === p1.backend.type)
                .filter((item) => p1.backend.mode === "Live").length
            ) +
              parseInt(
                accountData
                  .filter((item) => item.backend.type === p1.backend.type)
                  .filter((item) => p1.backend.mode === "Demo").length
              ) <
            parseInt(
              accountData
                .filter((item) => item.backend.type === p2.backend.type)
                .filter((item) => p2.backend.mode === "Live").length
            ) +
              parseInt(
                accountData
                  .filter((item) => item.backend.type === p2.backend.type)
                  .filter((item) => p2.backend.mode === "Demo").length
              )
              ? 1
              : parseInt(
                  accountData
                    .filter((item) => item.backend.type === p1.backend.type)
                    .filter((item) => p1.backend.mode === "Live").length
                ) +
                  parseInt(
                    accountData
                      .filter((item) => item.backend.type === p1.backend.type)
                      .filter((item) => p1.backend.mode === "Demo").length
                  ) >
                parseInt(
                  accountData
                    .filter((item) => item.backend.type === p2.backend.type)
                    .filter((item) => p2.backend.mode === "Live").length
                ) +
                  parseInt(
                    accountData
                      .filter((item) => item.backend.type === p2.backend.type)
                      .filter((item) => p2.backend.mode === "Demo").length
                  )
              ? -1
              : 0
          );
        }

        // this.selectedTab = result[0].backend.type
        return result;
      }
    },
    showICMPopup() {
      return this.$store.getters.get_icm_popup;
    },
    showIcmAcademyModalComputed() {
      if (this.$store.getters.get_profile.address !== undefined) {
        const userCountry =
          this.$store.getters.get_profile.address?.addr_country; // get user country
        const isIcmAcademyModal = this.$store.getters.get_icm_academy_modal; // get a boolean for ICM Academy modal
        const whitelabel = this.whitelabel;

        // Check the conditions
        //BR#52
        if (
          isIcmAcademyModal &&
          (whitelabel === "ICMVC" || whitelabel === "ICMMU" || whitelabel === "ICMSC") &&
          !["Malaysia", "Vietnam", "Thailand", "Indonesia"].includes(
            userCountry
          )
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },

// #BR#98 Mbeng 9/06/2025 For ICMMU Tax details
mounted() {
  const profile = this.$store.getters.get_profile;
  const accounts = this.$store.getters.get_profile?.trading_accounts || [];

    if (profile?.nic_fields?.length > 0) {
      this.checkTaxPopup(profile);
    };

  // BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
  if ( accounts && Array.isArray(accounts)
      ) {
         this.checkGroupEligibility(accounts);
      };

  this.checkWebinarPopup();   // Webinar popup //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
  this.checkWebinarenPopup();  // BR#124 - Mbeng - 10/09/2025
  this.checkWebinarAssiaPopup();  // BR#135 - Mbeng - 15/10/2025
  this.checkSpotIndicesPopup();  // BR#158 - Mbeng - 12/02/2026
},

  created() {
    this.$store.dispatch("account_data").catch((error) => {
      //console.error("Error dispatching 'account_data': ", error);
    });
    this.stage = process.env.VUE_APP_API_URL.includes("dev.")
      ? "dev"
      : process.env.VUE_APP_API_URL.includes("stage.")
      ? "stage"
      : "production";

    if (this.whitelabel === "GCCBrokers") {
      this.showGccDemoPopup = this.$store.getters.get_gcc_demo_popup;
    }

    if (this.whitelabel === "GCCBrokers") {
      this.showGccDemoPopup = this.$store.getters.get_gcc_demo_popup;
    }
  //BR#52
    if (this.whitelabel === "ICMVC" || this.whitelabel === "ICMMU" || whitelabel === "ICMSC") {
      this.fetchUserDocs();
      // Initialize the interval and save intervalId to the component instance
      this.intervalId = setInterval(() => this.fetchUserDocs(), 10000); // Fetch user data every 10 seconds
    }
    this.fetchProfileData();

    // Initialize the interval and save intervalId to the component instance
    this.accountDataIntervalId = setInterval(
      () => this.fetchProfileData(),
      15000
    ); // Fetch user data every 15 seconds
  },

  watch: {
    //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
    //BR#124 - Mbeng  - 10/09/2025 - add webinar popup
    // Re-check only when the relevant fields change
    profileLang() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },
    profileWL() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },
    profileCountry() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },


    get_profile: {
        handler(profile) {
          if (!profile) return;
          
          //console.log("👤 get_profile updated:", profile);

          // Tax popup
          if (Array.isArray(profile.nic_fields) && profile.nic_fields.length > 0) {
            console.log("✅ NIC fields loaded:", profile.nic_fields);
            this.checkTaxPopup(profile);
          } else {
            console.log("❌ NIC fields missing, retrying...");
            setTimeout(() => {
              const refreshed = this.$store.getters.get_profile;
              if (refreshed?.nic_fields?.length > 0) {
                console.log("✅ Retried and found NIC fields:", refreshed.nic_fields);
                this.checkTaxPopup(refreshed);
              } else {
                console.warn("⚠️ Still no NIC fields after delay");
              }
            }, 300);
          }

          // BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
          if (Array.isArray(profile.trading_accounts) && profile.trading_accounts.length > 0) {
            console.log("📈 Trading accounts found:", profile.trading_accounts);
            this.checkGroupEligibility(profile.trading_accounts);
          } else {
            console.warn("❌ No trading accounts found in profile");
          }

        },
        immediate: true,
        deep: true,
      },

    
  },

  methods: {
    fetchProfileData() {
      this.$store
        .dispatch("profile")
        .then((res) => {
          const profile = this.$store.getters["get_profile"];
          const state = profile.state;

          console.log("Profile state is: ", state, "Checking is in progress");
          if (state === "Full" || state === "Limited") {
            this.$store.dispatch("account_data").catch((error) => {
              console.error("Error dispatching 'account_data': ", error);
            });
          }

          if (state === "Full") {
            clearInterval(this.accountDataIntervalId);
            const checkWhenLiveAccountCreated = profile.trading_account?.find(
              (account) => account.Type === "Live"
            )?.created;
            const isLessThenMinute =
              new Date() - new Date(checkWhenLiveAccountCreated) < 60000;
            if (isLessThenMinute) {
              this.$notify({
                group: "foo",
                text: "Registration Complete, Live Account Added!",
                type: "success",
              });
            }

            console.log("Checking is done, current state is: ", state);
          }
        })
        .catch((error) => {
          console.error("Error in 'fetchProfileData': ", error);
        });
    },

    fetchUserDocs() {
      const documents = this.$store.getters.get_uploaded_documents?.results;
      const status = this.$store.getters.get_profile.state;

      const idProof = documents?.find(
        (document) => document.document_type === "ID Proof"
      );

      const needToFetch = idProof?.status !== 2 && status !== "Limited";
      if (needToFetch) {
        this.$store.dispatch("set_uploaded_documents");
      } else {
        clearInterval(this.intervalId);
      }
    },
    closeModal() {
      this.showAddDemoAccountModal = false;
      this.showAddAccountModal = false;
      this.showBecomeBrokerPopup = false;  // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
      this.showIcmAcademyModal = false;
      this.showSwapFreePopup = false; //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
      this.showWebinarPopup = false; //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
      this.showWebinarenPopup = false; //BR#124 - Mbeng  - 10/09/2025
      this.showWebinarAssiaPopup = false; //BR#135 - Mbeng  - 15/10/2025
      this.showSpotIndicesPopup = false; //BR#158 - Mbeng  - 12/02/2026
    },

    //#BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    startCountdown() {
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.lockMenu();
          clearInterval(this.intervalId);
        }
      }, 1000); // update every second
    },
    lockMenu() {
      this.menuLocked = true;
      this.$store.commit("LOCK_MENU_ITEMS"); // Vuex control
    },
    dismissPopup() {
      //clearInterval(this.intervalId);
      this.showTaxPopup = false;
      localStorage.setItem("tax_popup_dismissed", "true");
    },

    


    //BR#98 - Mbeng - show taxdetail popup if code !== TIN or value is empty - 8/7/2025 
    checkTaxPopup(profile) {
      const nicFields = profile.nic_fields || [];
      const requiredPriorities = [3, 4, 5, 6];

      // Look for at least one valid TIN in required priorities
      const hasValidTIN = requiredPriorities.some(priority => {
        const field = nicFields.find(n => n.priority === priority);
        return field && field.code === 'TIN' && field.value;
      });

      this.showTaxAlert = !hasValidTIN;
      this.showTaxPopup = !hasValidTIN;
      this.profileLoaded = true;
      this.userLoaded = true;
      },

      //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
    checkWebinarPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-08-25") && now <= new Date("2025-12-09");

      const matches =
        this.profileLang === "ar" &&
        (this.profileCountry !== "Malaysia" && this.profileCountry !== "Indonesia" && this.profileCountry !== "Thailand" && this.profileCountry !== "Vietnam") &&  //#BR#135
        this.profileWL === "ICMMU" &&
        //(this.profileWL === "ICMMU" || this.profileWL === "ICMVC") &&
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarPopup = !!matches;
    },

    handleWebinarClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },

  //BR#124 - Mbeng  - 10/09/2025 - add webinar popup
    checkWebinarenPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarenPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-08-25") && now <= new Date("2025-12-09");

      const matches =
        this.profileLang !== "ar" &&
        (this.profileCountry !== "Malaysia" && this.profileCountry !== "Indonesia" && this.profileCountry !== "Thailand" && this.profileCountry !== "Vietnam" ) &&  //#BR#135
        this.profileWL === "ICMMU" &&
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarenPopup = !!matches;
    },

    handleWebinarenClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarenPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },


    //BR#135 - Mbeng  - 15/10/2025 - add webinarAssia popup
    checkWebinarAssiaPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarAssiaPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-10-01") && now <= new Date("2025-12-31");

      const matches =
        this.profileWL === "ICMMU" && 
        (this.profileCountry === "Malaysia" || this.profileCountry === "Indonesia"|| this.profileCountry === "Thailand" || this.profileCountry === "Vietnam") &&  
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarAssiaPopup = !!matches;
    },

    handleWebinarAssiaClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarAssiaPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },


      //BR#158 - Mbeng  - 12/02/2026 - add spotindices popup
    checkSpotIndicesPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showSpotIndicesPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2026-02-13") && now <= new Date("2026-02-20");
      const matches =
        inRange;

      // Only show if rule matches and not dismissed this session
      //this.showSpotIndicesPopup = true;
      this.showSpotIndicesPopup = !!matches;
    },

    handleSpotIndicesClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showSpotIndicesPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },


    //BR#103 - Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group

    checkGroupEligibility(accounts) {
      fetch("/group_names.json")
        .then((res) => res.json())
        .then((data) => {
          const knownGroups = data.group_names || [];

          const userGroups = accounts.map((acc) =>
            acc.group_name ? acc.group_name.replace(/^.*\\/, "") : null
          );

          //console.log("👤 User's trading account groups:", userGroups);
          //console.log("📂 Loaded group_names.json:", knownGroups);

          const now = new Date();
          const startDate = new Date("2025-07-25");
          const endDate = new Date("2025-08-08");
          const inRange = now >= startDate && now <= endDate;

          // Check if any of the user's groups are in the known list
          const matchedGroups = userGroups.filter((g) => knownGroups.includes(g));
          const hasMatch = matchedGroups.length > 0;

          const hasActiveAccount = accounts.some(
            (acc) => acc.status === "active"
          );

          if (!hasMatch && userGroups.some(g => g)) {
            // 👤 Group exists but is not in the allowed list
           // console.log("❌ User has a group, but no match found in allowed list.");
            this.showSwapFreePopup = false;
            this.profileLoaded = true;
          } else if (hasMatch && hasActiveAccount && inRange) {
            // ✅ Show the popup
            this.showSwapFreePopup = true;
           // console.log("✅ Valid group found & account active & within date → Show popup");
          } else {
            // 🔒 All other cases: hide
            this.showSwapFreePopup = false;
            if (!hasActiveAccount) console.log("⚠️ No active trading account.");
            if (!inRange) console.log("📅 Not within popup date range.");
            console.log("🔒 Popup will NOT be shown.");
          }
        })
        .catch((err) => {
          console.error("⚠️ Error loading group_names.json:", err);
          this.showSwapFreePopup = false;
        });
    },
    checkAsset(name) {
      try {
        return require(`../../assets/${name}-tab-icon.png`);
      } catch (e) {
        return require(`../../assets/logo-placeholder.png`);
      }
    },
    closeGccPopup() {
      this.showGccDemoPopup = false;
      this.$store.commit("SET_GCC_DEMO_POPUP", false);
    },
    continueGccPopup() {
      this.showGccDemoPopup = false;
      this.$store.commit("SET_GCC_DEMO_POPUP", false);
      this.$router.push("/open-live-account");
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    clearInterval(this.accountDataIntervalId);
  },

   // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
   async sendBrokerRequest(data) {
      try {
        await fetch("/api/accounts/become-broker/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        alert("Your request has been submitted!");
      } catch (error) {
        console.error("Error submitting broker request:", error);
        alert("Something went wrong. Please try again.");
      }
  },
};
</script>
